export default function PHP_ltrim() {
  return (
    <div>
      <h1>PHP_ltrim</h1>
    </div>
  );
}
